module.exports = __webpack_public_path__ + "img/login-imediato-logo.e202f378.svg";